// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__FnS6A","image":"styles_image__b6ePY"};